// Colours of the flow zones (below, inside and above the recommended range) shared by the level history
// chart and the sparklines: the brand's bas / bon / haut (docs/BRAND.md). The dark theme uses lighter shades so
// the lines stay visible on navy. `now` is the brand gold of the "now" mark, never used for a level.
const LIGHT = {
  low: "#d64545",
  recommended: "#2e9b57",
  high: "#1f6fd1",
  none: "#78909c",
  now: "#e0a526",
  // Grey under the line and the dot outline
  area: "38, 50, 56",
  outline: "#ffffff",
};

const DARK = {
  low: "#f07070",
  recommended: "#5cc984",
  high: "#6aa6f0",
  none: "#90a4ae",
  now: "#e8b23a",
  area: "144, 202, 249",
  outline: "#17212c",
};

export function getZoneColors(dark) {
  return dark ? DARK : LIGHT;
}

// Pale bands behind the line: same in both themes, they are transparent
export const ZONE_BAND_COLORS = {
  low: "rgba(214, 69, 69, 0.12)",
  recommended: "rgba(46, 155, 87, 0.16)",
  high: "rgba(31, 111, 209, 0.12)",
};
